import instance from "../../utils/axios";

// Convert payload to FormData for consistent API format
const toFormData = (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val ?? ""));
  return formData;
};

// ✅ Save Video
export const saveVideo = async (payload) => {
    const response = await instance.post("/videoresources/save", toFormData(payload));
  return response.data;
};

// ✅ Update Video
export const updateVideo = async (payload) => {
  const response = await instance.post("/videoresources/update", toFormData(payload));
  return response.data;
};

// ✅ Delete Video
export const deleteVideo = async ({ _id }) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);
  const response = await instance.post("/videoresources/delete", formData);
  return response.data;
};

// ✅ Read Videos (filtered)
export const readVideos = async (payload) => {
  const response = await instance.post("/videoresources/read", toFormData(payload));
  return response.data;
};
